import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IBusinessInfoModel, IBusinessListModel } from "src/types/models/apiModels";

export class BusinessViewModel {
  private apiService: ApiService;

  constructor(accessToken: string) {
    this.apiService = new ApiService({ accessToken: accessToken });
  }

  async fetchListAsync(): Promise<IBusinessListModel[]> {
    const response = await this.apiService.getAsync<any>(
      "/onboard/businesses"
    );

    if (response) {
      if (response.scResponse && response.scResponse.code === 2000) {
        const sortedBusinesses = response.scResponse.data.sort((a: { businessCode: number; }, b: { businessCode: number; }) => {
          if (a.businessCode < b.businessCode) return -1; // a comes before b
          if (a.businessCode > b.businessCode) return 1; // a comes after b
          return 0; // a and b are equal
        });
        return sortedBusinesses;
      }

      return [];
    }

    return [];
  }

  async getBusiness(businessId: string): Promise<IBusinessInfoModel | undefined> {
    const response = await this.apiService.getAsync<IApiResponse<IBusinessInfoModel>>(
      `/onboard/business/${businessId}`
    );

    console.log(`response for get business`, response);

    if (response.scResponse.code === 2000) {
      return response.scResponse.data;
    }

    return undefined;
  }
}
